import React, { useState, useEffect } from 'react';
import OTPInput from 'otp-input-react';
import { useNavigate } from 'react-router-dom';
import useToast from '../../../util/hooks/useToast';

import Button from '../../../components/Button';
import formatSeconds from '../../../util/helpers/formatSeconds';
import ArrowRight from '../../../assets/svg_components/ArrowRight';
import { setResetOtp } from '../../../redux/slices/auth/forgotPassSlice';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { ReactComponent as ResendCodeIcon } from '../../../assets/images/resend-code-icon.svg';
import { FORGOT_PASSWORD_BY_EMAIL } from '../../../graphql/queries';

import ForgotPassVStyles from './ForgotPasswordVerifyScreen.module.scss';
import useCustomQuery from '../../../network/useCustomQuery';

const ForgotPasswordVerifyScreen = () => {
  const Toast = useToast();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { phone, email } = useAppSelector((state) => state.user);
  const [getForgotPasswordRealtor, forgotPasswordRealtorLoading, forgotPasswordRealtorData] =
    useCustomQuery({
      query: FORGOT_PASSWORD_BY_EMAIL,
      onError: () => {},
      onData: () => {}
    });

  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [time, setTime] = useState(120);

  useEffect(() => {
    if (error) {
      Toast.error(error);

      setError('');
    }
  }, [error]);

  useEffect(() => {
    let id: any;
    if (email && !phone) {
      id = setInterval(() => {
        setTime((prevTime) => prevTime - 1);
      }, 1000);
    } else if (phone && !email) {
      id = setInterval(() => {
        setTime((prevTime) => prevTime - 1);
      }, 1000);
    }
    return () => {
      clearInterval(id);
      setTime(120);
    };
  }, [email, phone]);

  useEffect(() => {
    if (forgotPasswordRealtorData?.forgotPasswordRealtor?.status === 200) {
      Toast?.success(forgotPasswordRealtorData?.forgotPasswordRealtor?.message);
      setTime(120);
    } else {
      setError(forgotPasswordRealtorData?.forgotPasswordRealtor?.message);
    }
  }, [forgotPasswordRealtorData]);

  const handleResendEmailOtp = () => {
    setError('');
    const payload = {
      email
    };
    getForgotPasswordRealtor({ variables: payload });
  };

  const onContinue = () => {
    dispatch(setResetOtp(pin));
    localStorage.setItem('otpPin', pin);
    navigate(`/password-reset?email=${email}`);
    setTime(0);
  };

  return (
    <div className={ForgotPassVStyles.forgotPass}>
      <div className={ForgotPassVStyles.forgotPass__content}>
        <h4 className={ForgotPassVStyles.forgotPass__headText}>Request Sent Successfully</h4>

        <p className={ForgotPassVStyles.forgotPass__subtext}>
          We have sent an email to{' '}
          <span className={ForgotPassVStyles.forgotPass__identity}>{email}</span> containing a
          verification code.
        </p>

        <div className={ForgotPassVStyles.forgotPass__pin}>
          <OTPInput
            className={ForgotPassVStyles.forgotPass__pinWrapper}
            inputClassName={ForgotPassVStyles.forgotPass__pinInput}
            value={pin}
            onChange={setPin}
            autoFocus={false}
            OTPLength={4}
            otpType="number"
            disabled={false}
            secure
          />
        </div>

        <div className={ForgotPassVStyles.forgotPass__instruction}>
          <div className={ForgotPassVStyles.forgotPass__notice}>
            <p className={ForgotPassVStyles.forgotPass__noticeText}>
              Having trouble finding your OTP? Check your Spam/Promotions folder. No OTP still?
              Click on &quot;Resend&quot; button.
            </p>
          </div>
        </div>

        <Button
          className={ForgotPassVStyles.forgotPass__button}
          title="Verify email address"
          isLoading={forgotPasswordRealtorLoading}
          disabled={forgotPasswordRealtorLoading || pin.length !== 4}
          onPress={onContinue}
        />
        <div className={ForgotPassVStyles.forgotPass__resendBeforeTimeout}>
          {time > 0 && (
            <>
              <div className={ForgotPassVStyles.forgotPass__redirect}>
                <div className={ForgotPassVStyles.forgotPass__redirectText}>
                  <ArrowRight
                    className={ForgotPassVStyles.forgotPass__redirectArrow}
                    stroke="#06080E"
                  />
                  <span
                    className={ForgotPassVStyles.forgotPass__redirectClickable}
                    onClick={() => {
                      navigate('/');
                    }}>
                    Go back to login
                  </span>
                </div>
              </div>
              <p className={ForgotPassVStyles.forgotPass__beforeTimeoutText}>
                <ResendCodeIcon />
                Resend code in :{' '}
                <span className={ForgotPassVStyles.forgotPass__resendTimer}>
                  {formatSeconds(time)}
                </span>
              </p>
            </>
          )}
          {time < 0 && (
            <>
              <div className={ForgotPassVStyles.forgotPass__resend}>
                <p className={ForgotPassVStyles.forgotPass__resendText}>
                  <span
                    className={`${ForgotPassVStyles.forgotPass__resendTimer} ${ForgotPassVStyles.forgotPass__resendClickable}`}
                    onClick={forgotPasswordRealtorLoading ? () => {} : handleResendEmailOtp}>
                    Resend code
                  </span>
                </p>
              </div>
              <div className={ForgotPassVStyles.forgotPass__redirect}>
                <div className={ForgotPassVStyles.forgotPass__redirectText}>
                  <ArrowRight
                    className={ForgotPassVStyles.forgotPass__redirectArrow}
                    stroke="#06080E"
                  />
                  <span
                    className={ForgotPassVStyles.forgotPass__redirectClickable}
                    onClick={() => {
                      navigate('/');
                    }}>
                    Go back to login
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordVerifyScreen;
